import { render, staticRenderFns } from "./PayoutsInProgressTable.vue?vue&type=template&id=f5b871ae&scoped=true&"
import script from "./PayoutsInProgressTable.vue?vue&type=script&lang=js&"
export * from "./PayoutsInProgressTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b871ae",
  null
  
)

export default component.exports